<template>
    <main>
        <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>

        <page-header-compact>
            Formatos de Urgencia
            <template v-slot:button>
                <router-link :to="{ name: 'historias.perfil.usuario', params: { idUsuario: usuario.id } }"
                    class="btn btn-success btn-sm shadow-sm mx-2">
                    Regresar al perfil del paciente <i class="fas fa-history fa-fw"></i>
                </router-link>
            </template>
        </page-header-compact>

        <div class="container-xl px-1">
            <cardInformacionUsuario :usuario="usuario" class="mt-2"></cardInformacionUsuario>
            <ul class="nav nav-tabs border-bottom-0 mt-2" id="mainTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active font-weight-bold" id="signos-vitales-tab" data-toggle="tab"
                        href="#signos-vitales" role="tab" aria-controls="signos-vitales" aria-selected="true">
                        <i class="fas fa-heartbeat mr-1"></i> Signos Vitales
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link font-weight-bold" id="control-liquidos-tab" data-toggle="tab"
                        href="#control-liquidos" role="tab" aria-controls="control-liquidos" aria-selected="false">
                        <i class="fas fa-tint mr-1"></i> Control de Líquidos
                    </a>
                </li>
            </ul>
            <div class="tab-content mt-2" id="mainTabContent">
                <div class="tab-pane fade show active" id="signos-vitales" role="tabpanel"
                    aria-labelledby="signos-vitales-tab">
                    <SignosVitales :idUsuario="idUsuario" :idHistoria="idHistoria" />
                </div>
                <div class="tab-pane fade" id="control-liquidos" role="tabpanel" aria-labelledby="control-liquidos-tab">
                    <ControlLiquidos :idUsuario="idUsuario" :idHistoria="idHistoria" />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import usuarioService from '@/services/usuarioService';
import SignosVitales from './componentes/SignosVitales.vue';
import ControlLiquidos from './controlLiquidos/index.vue';
import modalInformacionUsuario from '@/views/historias/base/informacionUsuario/modalInformacionUsuario';
import cardInformacionUsuario from '@/views/historias/base/informacionUsuario/cardInformacionUsuario';
import PageHeaderCompact from "@/components/layouts/content/page-header-compact";
export default {
    components: {
        SignosVitales,
        ControlLiquidos,
        modalInformacionUsuario,
        cardInformacionUsuario,
        PageHeaderCompact
    },
    data() {
        return {
            idUsuario: this.$route.params.idUsuario,
            idHistoria: this.$route.params.idHistoria,
            usuario: {},
        }
    },
    async mounted() {
        await this.cargarUsuario();
    },
    methods: {
        async cargarUsuario() {
            try {
                const response = await usuarioService.show(this.idUsuario);
                this.usuario = response.data;
            } catch (error) {
                console.error("Error al cargar el usuario", error);
            }
        }
    }
}
</script>

<style scoped>
.nav-tabs .nav-link {
    border: none;
    color: #69707a;
    padding: 1rem 1.5rem;
}

.nav-tabs .nav-link.active {
    color: #0061f2;
    border-bottom: 2px solid #0061f2;
    background-color: transparent;
}
</style>
